package co.maytes.standupbot.dashboard.components.widgets.icons

import androidx.compose.runtime.Composable

@Composable
fun LucideCopy(size: Int = 20, strokeColor: String = "currentColor") =
    LucideIcon(
        size = size,
        strokeColor = strokeColor,
        paths = listOf(
            "M10 8h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H10a2 2 0 0 1-2-2V10a2 2 0 0 1 2-2z",
            "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2",
        ),
    )
